import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { easterEggs } from "@/mocks/extras";

export default function EasterEggs() {
  return (
    <section id="eggs" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Details & Callbacks"
              title="彩蛋与细节：二刷时值得留意的线索"
              desc="影片有不少用心的呼应藏在细节里，第一次看很容易错过。下面这些线索不改变主线，却能让你更清楚地看到创作者的设计意图。"
            />
          </Reveal>

          <div className="mt-10 md:mt-14 space-y-3 md:space-y-4">
            {easterEggs.map((egg, index) => (
              <Reveal key={egg.id} delay={index * 60}>
                <div className="group flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-accent-400 transition-colors">
                  <span className="w-14 h-14 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950 font-heading font-bold text-lg shrink-0">
                    {egg.index}
                  </span>
                  <div className="flex-1">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
                      <i className="ri-magic-line text-accent-600" />
                      {egg.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {egg.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}